import { Button, Stack, Text } from '@careflux/primitives';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { PaginationProps } from './components.types';

export const ComparisonsPagination = ({ page, totalPages, totalCount, shownCount, onPageChange }: PaginationProps) => (
  <Stack direction="horizontal" justify="between" align="center">
    <Text size="sm" color="muted">{`Sýni ${shownCount} af ${totalCount} lotum`}</Text>
    <Stack direction="horizontal" gap="sm" align="center">
      <Button
        variant="outline"
        size="icon-sm"
        aria-label="Fyrri síða"
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1}
      >
        <ChevronLeft />
      </Button>
      <Text size="sm">{`Síða ${page} af ${totalPages}`}</Text>
      <Button
        variant="outline"
        size="icon-sm"
        aria-label="Næsta síða"
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages}
      >
        <ChevronRight />
      </Button>
    </Stack>
  </Stack>
);
